import React, { useEffect, useRef, useState } from 'react';
import { Avatar } from '.';
import sharedStyles from '../shared.module.css';

export const Ellipsis: React.FC = () => {
    const [display, setDisplay] = useState(false);

    const myRef = useRef<HTMLDivElement | null>(null);

    // wait 1s to start displaying ellipsis
    useEffect(() => {
        const timer = setTimeout(() => {
            setDisplay(true);
        }, 1000);

        return () => clearTimeout(timer); // clear the timeout if ellipsis is about to be removed from DOM
    }, []);

    useEffect(() => {
        if (display && myRef && myRef.current) {
            myRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, [display]);

    return display ? (
        <div ref={myRef}>
            <div className={sharedStyles.botMessageRowContainer}>
                <div className={sharedStyles.botMessageContainer}>
                    <div className={sharedStyles.botMessageAvatar}>
                        <Avatar />
                    </div>
                    <div
                        className={sharedStyles.botMessageBubble}
                        style={{ width: '20px' } as any}
                    >
                        <div className={sharedStyles.ellipsis}>{'\u2026'}</div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};
